import $ from "jquery";
import CONFIG from "@bd-core/config";
import {
  Chart,
  RadarController,
  LineElement,
  PointElement,
  RadialLinearScale,
  Filler,
} from "chart.js";
import BD_GAME_LOGIC from "@bd-core/game-logic";

export const NuclearQuickscan = (categories) => {
  // if (CONFIG.siteSetup !== "nuclear-quickscan") return;

  // Toggle Consent Drawer
  $(".js-result-next").on("click", () => {
    $("#resultScreen").toggleClass("is-consent-open");
  });

  $(".js-close-consent").on("click", () => {
    $("#resultScreen").toggleClass("is-consent-open");
  });

  // Toggle Result Data Z-Index
  $(".chart-label").on("mouseenter", () => {
    $(".resultScreen__data").css("z-index", "4");
  });

  $(".chart-label").on("mouseleave", () => {
    $(".resultScreen__data").css("z-index", "2");
  });

  // Render Results Chart
  const $el = document.getElementById("testChart");
  if (!$el) return;

  Chart.register(
    RadarController,
    LineElement,
    PointElement,
    RadialLinearScale,
    Filler,
  );

  const data = categories.map((category) => category.score).slice(0, 4);
  const labels = categories.map((category) => category.name).slice(0, 4);
  const $labels = $(".chart-label");
  $labels.each((index, label) => {
    $(label).html(labels[index]);
  });

  // @ts-ignore
  let ctx = $el.getContext("2d");

  const max = Math.max.apply(Math, data);

  new Chart(ctx, {
    type: "radar",
    data: {
      labels: labels,
      datasets: [
        {
          data: data,
          fill: true,
          backgroundColor: "rgba(255, 127, 34, 0.56)",
          borderColor: "rgb(255, 127, 34)",
          pointBackgroundColor: "rgb(255, 127, 34)",
          pointBorderColor: "rgb(255, 127, 34)",
        },
      ],
    },
    options: {
      animation: false,
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: {
          top: 10,
          right: 10,
          bottom: 10,
          left: 10,
        },
      },
      elements: {
        line: {
          borderWidth: 2,
        },
        point: {
          radius: 6,
        },
      },
      scales: {
        r: {
          angleLines: {
            display: false,
          },
          grid: {
            display: false,
          },
          ticks: {
            display: false,
          },
          pointLabels: {
            display: false,
          },
          beginAtZero: true,
          min: 0,
          max,
        },
      },
    },
  });

  // Initialize form state - disable inputs and button by default
  const $consentCheckbox = $("#contact_consent");
  const $submitButton = $("#js-sumbit-contact-btn");
  const $formInputs = $(
    "#consentForm input[type='text'], #consentForm input[type='email'], #consentForm input[type='tel']",
  );

  // Function to toggle form state based on consent checkbox
  const toggleFormState = () => {
    const isChecked = $consentCheckbox.is(":checked");
    $formInputs.prop("disabled", !isChecked);
    $submitButton.prop("disabled", !isChecked);

    // Add visual feedback for disabled state
    if (isChecked) {
      $submitButton.removeClass("disabled");
      $formInputs.removeClass("disabled");
    } else {
      $submitButton.addClass("disabled");
      $formInputs.addClass("disabled");
    }
  };

  // Initialize form as disabled
  toggleFormState();

  // Listen for consent checkbox changes
  $consentCheckbox.on("change", toggleFormState);

  // Validation functions
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateRequired = (value) => {
    return value && value.trim().length > 0;
  };

  const showValidationError = (field, message) => {
    // Remove existing error
    field.siblings(".validation-error").remove();
    // Add error message
    field.after(
      `<span class="validation-error" style="color: red; font-size: 12px; margin-top: -16px;">${message}</span>`,
    );
    field.addClass("error");
  };

  const clearValidationErrors = () => {
    $(".validation-error").remove();
    $(".error").removeClass("error");
  };

  $("#js-sumbit-contact-btn").on("click", (e) => {
    e.preventDefault();

    // Check if consent is given before proceeding
    if (!$consentCheckbox.is(":checked")) {
      return;
    }

    // Clear previous validation errors
    clearValidationErrors();

    const fieldValue = (selector) => String($(selector).val() ?? "").trim();
    const organizationName = fieldValue("#organization_name");
    const organizationProfile = fieldValue("#organization_profile");
    const organizationScopeOfDelivery = fieldValue(
      "#organization_scope_of_delivery",
    );
    const organizationContactPerson = fieldValue("#organization_contact_person");
    const organizationEmail = fieldValue("#organization_email");
    const organizationPhone = fieldValue("#organization_phone");

    // Validate organization name
    if (!validateRequired(organizationName)) {
      showValidationError(
        $("#organization_name"),
        $("#organization-name-required-text").text(),
      );
      return;
    }
    // Validate organization profile
    if (!validateRequired(organizationProfile)) {
      showValidationError(
        $("#organization_profile"),
        $("#organization-profile-required-text").text(),
      );
      return;
    }
    // Validate organization scope of delivery
    if (!validateRequired(organizationScopeOfDelivery)) {
      showValidationError(
        $("#organization_scope_of_delivery"),
        $("#organization-scope-of-delivery-required-text").text(),
      );
      return;
    }

    // Validate contact person
    if (!validateRequired(organizationContactPerson)) {
      showValidationError(
        $("#organization_contact_person"),
        $("#organization-contact-person-required-text").text(),
      );
      return;
    }

    // Validate email
    if (!validateRequired(organizationEmail)) {
      showValidationError(
        $("#organization_email"),
        $("#organization-email-required-text").text(),
      );
      return;
    }
    if (!validateEmail(organizationEmail)) {
      showValidationError(
        $("#organization_email"),
        $("#organization-email-invalid-text").text(),
      );
      return;
    }

    // Phone number is optional - no validation needed

    // All validation passed, proceed with submission
    // Disable button to prevent double submission
    $submitButton.prop("disabled", true).text($("#submitting-text").text());

    $.ajax({
      url: CONFIG.ajaxUrl,
      type: "POST",
      data: {
        nonce: CONFIG.nonce,
        action: "submit_contact",
        organization_name: organizationName,
        organization_profile: organizationProfile,
        organization_scope_of_delivery: organizationScopeOfDelivery,
        organization_contact_person: organizationContactPerson,
        organization_email: organizationEmail,
        organization_phone: organizationPhone,
      },
    })
      .done(() => {
        BD_GAME_LOGIC.goToDefaultNextBlock();
        const consentForm = /** @type {HTMLFormElement | undefined} */ (
          $("#consentForm").get(0)
        );
        consentForm?.reset();
        $consentCheckbox.prop("checked", false);
      })
      .fail((response) => {
        alert("Error submitting form. Please try again.");
        console.error(response);
      })
      .always(() => {
        setTimeout(() => {
          // Reset form
          toggleFormState();
          $submitButton.text("Submit");
          $submitButton.prop("disabled", false);
        }, 100);
      });
  });

  $(".js-result-finish").on("click", () => {
    BD_GAME_LOGIC.goToDefaultNextBlock();
  });
};
